import React, { useState } from 'react';
import { Card, Table, Tag, Button, Modal, Form, Input, Space, message, Statistic, Row, Col } from 'antd';
import { SafetyCertificateOutlined, PlusOutlined, DeleteOutlined, ReloadOutlined, CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  useListSslMonitorsQuery, useAddSslMonitorMutation, useDeleteSslMonitorMutation,
  useCheckAllSslMutation, useCheckSingleSslMutation
} from '../store/api';

const MonitorSsl = () => {
  const { data = [], isLoading, refetch } = useListSslMonitorsQuery();
  const [addMonitor] = useAddSslMonitorMutation();
  const [deleteMonitor] = useDeleteSslMonitorMutation();
  const [checkAll, { isLoading: checking }] = useCheckAllSslMutation();
  const [checkOne] = useCheckSingleSslMutation();
  const [modal, setModal] = useState(false);
  const [form] = Form.useForm();

  const valid = data.filter(m => m.estado === 'valido').length;
  const expiring = data.filter(m => m.estado === 'por_vencer').length;
  const expired = data.filter(m => m.estado === 'vencido' || m.estado === 'error').length;

  const handleAdd = async () => {
    try {
      const values = await form.validateFields();
      await addMonitor(values).unwrap();
      message.success('Monitor SSL creado'); setModal(false); form.resetFields(); refetch();
    } catch { message.error('Error'); }
  };

  const columns = [
    { title: 'Dominio', dataIndex: 'dominio', render: d => <strong>{d}</strong> },
    { title: 'Estado', dataIndex: 'estado', render: s => {
      const conf = { valido: { color: 'green', icon: <CheckCircleOutlined /> }, por_vencer: { color: 'orange', icon: <WarningOutlined /> }, vencido: { color: 'red', icon: <CloseCircleOutlined /> }, error: { color: 'default', icon: <CloseCircleOutlined /> } };
      const c = conf[s] || conf.error;
      return <Tag color={c.color} icon={c.icon}>{s?.toUpperCase()}</Tag>;
    }},
    { title: 'Días restantes', dataIndex: 'dias_restantes', render: d => {
      if (d == null) return '-';
      const color = d > 30 ? '#52c41a' : d > 7 ? '#faad14' : '#f5222d';
      return <span style={{ color, fontWeight: 600 }}>{d} días</span>;
    }},
    { title: 'Emisor', dataIndex: 'emisor' },
    { title: 'Válido desde', dataIndex: 'valido_desde', render: d => d ? dayjs(d).format('DD/MM/YYYY') : '-' },
    { title: 'Válido hasta', dataIndex: 'valido_hasta', render: d => d ? dayjs(d).format('DD/MM/YYYY') : '-' },
    { title: 'Último check', dataIndex: 'ultimo_check', render: d => d ? dayjs(d).format('DD/MM HH:mm') : '-' },
    { title: '', key: 'act', width: 80, render: (_, r) => (
      <Space size={4}>
        <Button size="small" icon={<ReloadOutlined />} onClick={async () => { await checkOne(r.id).unwrap(); message.success('Verificado'); refetch(); }} />
        <Button size="small" danger icon={<DeleteOutlined />} onClick={() => Modal.confirm({
          title: '¿Eliminar?', onOk: async () => { await deleteMonitor(r.id).unwrap(); refetch(); }
        })} />
      </Space>
    )},
  ];

  return (
    <div className="page-container fade-in">
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title"><SafetyCertificateOutlined style={{ marginRight: 8 }} />Monitor SSL</h1>
          <div className="page-subtitle">{data.length} certificados monitoreados</div>
        </div>
        <Space>
          <Button icon={<ReloadOutlined />} onClick={async () => { await checkAll().unwrap(); message.success('Verificación completada'); refetch(); }} loading={checking}>Verificar Todos</Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { form.resetFields(); setModal(true); }}>Agregar Dominio</Button>
        </Space>
      </div>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col xs={8}><Card size="small"><Statistic title="Válidos" value={valid} valueStyle={{ color: '#52c41a' }} prefix={<CheckCircleOutlined />} /></Card></Col>
        <Col xs={8}><Card size="small"><Statistic title="Por vencer" value={expiring} valueStyle={{ color: '#faad14' }} prefix={<WarningOutlined />} /></Card></Col>
        <Col xs={8}><Card size="small"><Statistic title="Vencidos/Error" value={expired} valueStyle={{ color: '#f5222d' }} prefix={<CloseCircleOutlined />} /></Card></Col>
      </Row>

      <Card bordered={false} bodyStyle={{ padding: 0 }}>
        <Table columns={columns} dataSource={data} rowKey="id" loading={isLoading} pagination={{ pageSize: 15 }} size="middle" scroll={{ x: true }} />
      </Card>

      <Modal title="Agregar Monitor SSL" open={modal} onOk={handleAdd} onCancel={() => setModal(false)} okText="Crear">
        <Form form={form} layout="vertical">
          <Form.Item name="dominio" label="Dominio" rules={[{ required: true }]}><Input placeholder="ejemplo.com" /></Form.Item>
          <Form.Item name="puerto" label="Puerto" initialValue={443}><Input type="number" /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MonitorSsl;
